import { Link } from 'gatsby';
import * as React from 'react';
import HamburgerMenu from './HamburgerMenu';
import styles from './Header.module.scss';
import Text from '../atoms/Text';
import Image from '../atoms/Image';

interface State {
  isMenuOpen: boolean;
}
interface Props { }

class Header extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      isMenuOpen: false,
    };
  }

  toggleHamburgerMenu = () => {
    this.setState({ isMenuOpen: !this.state.isMenuOpen });
  };

  render() {
    return (
      <div className={styles.Header}>
        <Link to="https://www.hrbrain.co.jp" className={styles.Header__logo}>
          <Image
            alt="HRBrain"
            path="Company-logo.svg"
            className={styles.Header__logo__primary}
          />
        </Link>
      </div>
    );
  }
}

export default Header;
